export default __webpack_public_path__ + "static/media/SD.8a8eaa88.svg";